export const TRACK_EVENT_COMMAND = "trackEvent";
export const PAGE_VIEW_EVENT = "pageView";
export const CLICK_EVENT = "onClick";